export const HOME_PAGE_CHANGE_TAB = 'HOME_PAGE_CHANGE_TAB';

export function changeHomeTabAction(index) {
  return {
    type: HOME_PAGE_CHANGE_TAB,
    payload: index
  };
}
